import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_user_tasks from '@/locales/keys/i18n_page_user_tasks.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { useTranslation } from 'react-i18next';

export function U_BUTTON__user_tasks_hide_unused() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_USER_TASKS);

  const { page_tasks_hide_unused } = use_slice_ui(['page_tasks_hide_unused']);

  const i18n_key_tooltip = t(
    page_tasks_hide_unused ? i18n_page_user_tasks.button.user_tasks_hide_unused.title_show : i18n_page_user_tasks.button.user_tasks_hide_unused.title_hide,
  );

  /*
   * EVENTS
   */
  function onClick(e: React.MouseEvent) {
    e?.stopPropagation();

    dispatch(LOCAL__ui_set_boolean({ value: !page_tasks_hide_unused, key: 'page_tasks_hide_unused' }));
  }

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__tooltip tooltip_title={i18n_key_tooltip} side="right">
      <UI_PRIMITIVE__button_with_icon_animated
        className="w-10"
        size="square-10"
        variant="no-border-on-bar"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
        {...{ onClick }}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={page_tasks_hide_unused ? ICON__eye_solid : ICON__eye_slash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
